var closeIconButton = 'fx_2d2fb1e5_1rzdflr0';

export { closeIconButton };
//# sourceMappingURL=closeIconButton.vanilla.mjs.map
